import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowRight, Headset, Search } from "lucide-react";
import { TicketList } from "@/components/support/TicketList";
import { TicketThread } from "@/components/support/TicketThread";
import { useTickets } from "@/components/support/useTickets";
import { SupportRatings } from "@/components/support/SupportRatings";

const FILTERS = [["all", "الكل"], ["open", "مفتوحة"], ["in_progress", "قيد المعالجة"], ["closed", "مغلقة"]];

export default function SupportDesk() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("open");
  const [q, setQ] = useState("");
  const [selected, setSelected] = useState(null);
  const { tickets, load } = useTickets(status);
  const all = useTickets("all");
  const needle = q.trim().toLowerCase();
  const shown = tickets.filter((t) => !needle || [t.subject, t.user_name, t.user_email, String(t.number)].some((v) => (v || "").toLowerCase().includes(needle)));
  const ticket = all.tickets.find((t) => t.id === selected);
  const count = (s) => all.tickets.filter((t) => s === "all" || t.status === s).length;
  const refresh = () => { load(); all.load(); };

  return (
    <Shell title="واجهة خدمة العملاء" subtitle="الرد على تذاكر العملاء والورش ومقدمي السطحات" icon={Headset}
      actions={
        <div className="flex gap-2">
          <SupportRatings admin={user.role === "admin"} />
          {user.role === "admin" && (
            <Button variant="outline" className="rounded-full gap-2" onClick={() => navigate("/admin")} data-testid="desk-back-admin">
              <ArrowRight className="w-4 h-4" /> لوحة الإدارة
            </Button>
          )}
        </div>
      }>
      <div className="grid lg:grid-cols-[380px_1fr] gap-5">
        <Card className={`overflow-hidden ${ticket ? "hidden lg:block" : ""}`}>
          <div className="p-3 border-b border-border space-y-3">
            <Tabs value={status} onValueChange={setStatus} dir="rtl">
              <TabsList className="w-full grid grid-cols-4 h-auto">
                {FILTERS.map(([k, l]) => (
                  <TabsTrigger key={k} value={k} className="text-xs py-1.5" data-testid={`desk-filter-${k}`}>{l} ({count(k)})</TabsTrigger>
                ))}
              </TabsList>
            </Tabs>
            <div className="relative">
              <Search className="w-4 h-4 absolute top-1/2 -translate-y-1/2 start-3 text-muted-foreground" />
              <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="بحث بالاسم، البريد، الموضوع أو رقم التذكرة" className="ps-9" data-testid="desk-search-input" />
            </div>
          </div>
          <div className="max-h-[560px] overflow-y-auto">
            <TicketList tickets={shown} selectedId={selected} onSelect={setSelected} staff />
          </div>
        </Card>
        <Card className={ticket ? "" : "hidden lg:block"}>
          {ticket && (
            <Button variant="ghost" size="sm" className="lg:hidden m-3 mb-0 gap-1" onClick={() => setSelected(null)} data-testid="desk-mobile-back">
              <ArrowRight className="w-4 h-4" /> كل التذاكر
            </Button>
          )}
          <TicketThread ticket={ticket} meId={user.id} staff onChanged={refresh} />
        </Card>
      </div>
    </Shell>
  );
}
